import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { UserInterface } from 'src/app/auth/interfaces/user-interface';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  baseUrl = environment.DOMAIN;

  constructor(private httpClient: HttpClient) {}

  requestAuthorization(): Observable<any> {
    const userLogin = {
      u: environment.CREDENTIALS_FAC.u,
      p: environment.CREDENTIALS_FAC.p,
    };
    var headers = new HttpHeaders().set('skipBearer', '');
    return this.httpClient.post(
      `${this.baseUrl}/${environment.API.WEB.TOKEN}`,
      userLogin,
      { headers }
    );
  }

  login(username: string, password: string): Observable<any> {
    // this.getToken();
    var authToken = this.getTokenStorage();

    const loginData = { u: username, p: password };

    var headers = new HttpHeaders().append('skipBearer', '');
    headers = headers
      .set('Content-Type', 'application/json')
      .set('IH', environment.IH_INICIAL)
      .set('Authorization', `Bearer ${authToken}`);

    return this.httpClient.post(
      `${this.baseUrl}/${environment.API.LOGIN.Authenticate}`,
      loginData,
      { headers }
    );
  }

  saveToken(ih_code: string, idUsuario?: string | null): void {
    sessionStorage.setItem('ihCode', ih_code);
    if (idUsuario) sessionStorage.setItem('id_usuario', idUsuario);
  }

  getTokenStorage(): string | null {
    return (
      localStorage.getItem('authToken') || sessionStorage.getItem('authToken')
    );
  }

  checkCambiarPassword(IdUsuarioEncrypt: string): Observable<any> {
    const checkData = { IdUsuarioEncrypt: IdUsuarioEncrypt };
    var headers = new HttpHeaders().set('skipBearer', '');
    return this.httpClient.post(
      `${this.baseUrl}/${environment.API.AREA_CLIENTES.PermitirCambiarLogin}`,
      checkData,
      { headers }
    );
  }

  cambiarPassword(
    IdUsuarioEncrypt: string,
    NuevaClave: string
  ): Observable<any> {
    const passwordData = {
      IdUsuarioEncrypt: IdUsuarioEncrypt,
      NuevaClave: NuevaClave,
    };
    var headers = new HttpHeaders().set('skipBearer', '');
    return this.httpClient.post(
      `${this.baseUrl}/${environment.API.AREA_CLIENTES.CambiarLogin}`,
      passwordData,
      { headers }
    );
  }

  getUsuario(): Observable<UserInterface> {
    //console.log("getUsuario");
    var headers = new HttpHeaders();
    var IdUsuario: string = this.getIdUsuario() ?? ''; // Manejo de null
    const usuarioData = { IdUsuarioEncrypt: IdUsuario };
    //console.log(usuarioData);
    return this.httpClient
      .post(
        `${this.baseUrl}/${environment.API.AREA_CLIENTES.ObtenerUsuario}`,
        usuarioData,
        { headers }
      )
      .pipe(
        map((response: any) => {
          //console.log("mapGetUsuario");
          const mappedUsuario: UserInterface = {
            idUsuario: response.idUsuario,
            idUsuarioEncrypt: response.idUsuarioEncrypt,
            email: response.email,
            num_documento: response.num_Documento,
            nombre: response.nombre,
          };
          //console.log(mappedUsuario);
          return mappedUsuario;
        }),
        catchError((error) => {
          return throwError(
            () => new Error(error.message || 'Error fetching usuario')
          );
        })
      );
  }

  getIdUsuario(): string | null {
    //console.log("getIdUsuario");
    return sessionStorage.getItem('id_usuario');
  }

  isLoggedIn(): Observable<boolean> {
    if (this.getIdUsuario()?.trim()) {
      return of(true);
    } else return of(false);
  }

  logout(): Observable<boolean> {
    this.removeToken();
    return of(true);
  }

  removeToken() {
    sessionStorage.removeItem('id_usuario');
    sessionStorage.removeItem('ihCode');
    localStorage.removeItem('id_poliza');
    localStorage.removeItem('num_documento');
  }

  resetPassword(email: string): Observable<any> {
    const resetData = { email: email };
    var headers = new HttpHeaders().set('skipBearer', '');
    return this.httpClient.post(
      `${this.baseUrl}/${environment.API.AREA_CLIENTES.RecuperarLogin}`,
      resetData,
      { headers }
    );
  }
}
